import { Grid } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Grid)`
  #checkbox {
    margin: 2rem 0;
  }
`;
